<template>
  <div class="black-bg" v-if="shown" @click="close">
    <vue-scroll :ops=ops>
        <div class="close" ref="clo"></div>
        <img :src="src" alt="" class="bg-img" ref="src">
    </vue-scroll>
  </div>
</template>

<script>
export default {
    data(){
        return{
            shown:false,
            ops:{bar:{
                opacity:0,
            }}
        }
    },
    props:{
        src:{
            default:'',
            type:String,
        },
        show:{
            default:false,
            type:Boolean
        }
    },
    methods:{
        close(e){
            if(this.$refs.src.contains(e.target)) return;
            this.shown=false
            this.$emit('change',false)
        }
    },
    watch:{
        show: {
            handler: function (newdata) {
               this.shown=newdata
               this.$nextTick(()=>{

                   console.log(!!this.$refs.src,!!this.$refs.clo)
                   if(!!this.$refs.src&&!!this.$refs.clo){
                       var src=this.$refs.src.getBoundingClientRect(),clo=this.$refs.clo;
                    console.log(src.left+src.width)
                       clo.style.left=src.left+src.width+'px'
                   }
               })
            },
            // deep: true,
            // immediate: true,
        },
    }
}
</script>

<style scoped>
.black-bg{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: table-cell;
    text-align: center;
    z-index: 999999;
    overflow: auto;
}
.bg-img{
    margin: 0 auto;
    margin-top:100px ;
}
.close{
    cursor: pointer;
    width: 39px;
    height: 39px;
    position: absolute;
    top: 60px;
    z-index: 999999;
    background: url('../assets/img/guanb.png');
}
</style>